import React from "react"
import { SwiperSlide } from "swiper/react"

import {
  StaticReviewBlockOutput,
  StaticReviewOutput,
} from "contexts/settings/Integrations/integrationsSettings-types"

import { Slider } from "components/testimonial/Slider"
import { SliderController } from "components/testimonial/SliderController"
import { SliderPagination } from "components/testimonial/SliderPagination"
import { Testimonial } from "components/testimonial/Testimonial"
import { TestimonialBanner } from "components/testimonial/TestimonialBanner"
import { useSlider } from "components/testimonial/hooks/useSlider"
import { useStaticReviewData } from "./hooks/useStaticReviewData"
import { BackgroundImage } from "components/testimonial/assets/BackgroundImage"

interface StaticReviewBlockProps {
  staticReviews: StaticReviewOutput[] | StaticReviewBlockOutput
  type?: "static-review" | "static-review-block"
}

export const StaticReview = ({
  // type = "static-review",
  staticReviews,
}: StaticReviewBlockProps) => {
  const {
    activeIndex,
    handleNextSlide,
    handlePrevSlide,
    handlePagination,
    handleSetActiveIndex,
    handleSetSwiperInstance,
    handleSetSwiper2Instance,
    swiper1,
    swiper2,
  } = useSlider()

  const { hasMoreThan1Review, heading, reviews, subHeading } =
    useStaticReviewData(staticReviews)

  const bgImageClass = "fr-testimonial__background-image"
  const testimonialWithSlider = hasMoreThan1Review
    ? `${bgImageClass} ${bgImageClass}--with-slider`
    : `${bgImageClass}`

  return (
    <TestimonialBanner
      hasSliderWithNavigation={hasMoreThan1Review}
      heading={heading}
      subHeading={subHeading}
    >
      <Slider
        controller={{ control: swiper2 }}
        onActiveIndexChange={swiper => {
          handleSetActiveIndex(swiper.activeIndex + 1)
        }}
        onSwiper={handleSetSwiperInstance}
      >
        <BackgroundImage className={testimonialWithSlider} />

        {reviews.map(({ review, reviewer, reviewImage }, index) => (
          <SwiperSlide key={index}>
            <Testimonial
              avatar={reviewImage}
              review={review}
              reviewerName={reviewer}
            />
          </SwiperSlide>
        ))}
      </Slider>
      {hasMoreThan1Review && (
        <>
          <SliderPagination
            activeIndex={activeIndex}
            control={swiper1}
            handlePagination={handleSetSwiper2Instance}
            numberOfReviews={reviews.length}
            onPaginationClick={handlePagination}
          />
          <SliderController
            activeIndex={activeIndex}
            numberOfReviews={reviews.length}
            onSlideNext={handleNextSlide}
            onSlidePrev={handlePrevSlide}
          />
        </>
      )}
    </TestimonialBanner>
  )
}
